var _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscudo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 840,
    height: 960,
    id: "Armas_nacionales_del_Per\\xFA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "soportes"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1 0 0 1 840 0)",
    id: "bandera_diestra",
    style: {
      stroke: "#000",
      strokeWidth: 0.5,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 800,
    height: 935,
    xlinkHref: "#bandera_siniestra"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.816 3.666)",
    id: "bandera_siniestra",
    style: {
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.184 803.334L602.26 317.025l174.156-148.763-6.218 508.77c-1.371 112.18-104.197 282.657-375.014 126.302z",
    id: "path6659",
    style: {
      fill: "#d91023",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.656 495.188c-11.497 9.985-32.416 4.191-34.812 23.593-1.338 10.854-15.496 10.357-19.657 19.219-10.655 22.708-28.851 13.477-34.406 21.094-8.7 11.913-24.242 23.095-37 20.187-14.322-3.267-29.085 12.707-42.687 22.25-24.19 16.97-47.344 9.896-47.344 69.313 0 23.337-1.4 53.047 5.719 63.656 14.231 21.218 37.94 23.04 65.031 29.563 5.09 1.22 18.901.446 40.813 7.25 9.618 2.985 26.834 2.73 37.875 5.093 7.845 1.68 28.432 3.716 40.353 9.539 15.599-31.3 21.888-55.195 23.396-85.789h.032c.135-2.856.247-5.692.28-8.468l2.407-196.5z",
    transform: "translate(14.961 -14.666)",
    id: "path6663",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.187 462.593c7.017 14.815 4.007 43.392 4.007 62.444 0 21.164 1.003 42.333 1.003 62.444",
    id: "path6665",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.125 484.815c15.036 19.052 10.026 79.384 10.026 106.896",
    id: "path6667",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.836 489.65c-4.007 17.993-11.029 48.688-3.01 65.622 1.004 2.112 2.007 12.697 2.007 16.933v17.993",
    id: "path6669",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.858 488.663c2.006 14.815 1.003 33.867 1.003 48.682 0 6.354 4.013 15.88 4.013 22.229v13.756",
    id: "path6671",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.361 512.268c-1.263 11.566-2.646 24.185-3.91 35.746-1.156 10.513.68 21.397-.465 31.904-.465 4.212-3.299 20.912 4.018 18.609",
    id: "path6673",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.994 527.586c.766 10.393-1.031 22.073-3.44 32.4-.669 2-.176 10.041.096 12.393l-1.008 2.991c-.33.994 1.377 11.74 1.377 11.74l-.669 1.999c.55 4.697-1.797 11.68 2.925 13.445",
    id: "path6675",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.96 696.803c-3.84 16.609-6.684 45.33-14.035 58.685-4.282 7.235-11.193 18.005-12.509 25.75-.22 1.293-4.501 8.528-5.71 9.652-1.208 1.124-2.41 2.243-3.4 2.075-.988-.168-4.393 1.906-3.737-1.958",
    id: "path6677",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.143 669.733c-5.611 22.899-8.666 48.897-12.3 72.143-1.416 9.035-5.797 17.562-9.974 24.79-1.395 2.411-9.346 14.289-11.33 13.942",
    id: "path6679",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.083 682.101c-2.87 14.114-6.957 39.75-12.785 51.738-2.228 5.407-4.236 15.284-6.464 20.69-2.228 5.407-5.823 11.989-6.974 17.635-.863 4.23-2.582 12.704-4.526 16.694-.284 1.41-6.042 7.517-6.615 10.338-.29 1.41-3.31 5.172-2.448.935",
    id: "path6681",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.193 689.682c-1.859 6.438-4.647 16.102-6.5 22.546-2.324 8.054-10.044 16.132-12.367 24.185-2.783 9.664-10.044 16.126-12.362 24.18-1.859 6.438-6.807 18.926-9.13 26.98",
    id: "path6683",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.002 700.21c-5.617 17.405-8.666 37.17-12.304 54.833-1.412 6.875-5.798 13.349-9.976 18.848-1.394 1.83-9.346 10.86-11.324 10.597",
    id: "path6685",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29 21)",
    id: "g7725",
    style: {
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.786 795.596c0 8.132 14.12 35.768 24.492 63.7 1.077 2.913 3.085 6.725 1.317 9.394-10.327 15.599 8.157 25.719 8.157 25.719s3.015 3.638 3.786 6.713c1.916 7.66-5.99 6.11-12.435 5.96-6.824-.162 8.343 27.752 8.343 27.752s-50.901-1.317-51.508-23.103c0-9.544 11.438-14.594 10.055-22.055-.227-1.245-5.69.85-10.31-.473-4.619-1.316-5.14-6.193-5.05-7.874.13-2.304.153-4.267.477-6.2 1.02-6.055 23.146-24.269-2.313-27.655-1.887-.252-9.193 3.339-9.096 1.538.957-17.448 21.214-45.17 20.777-62.606-.159-6.355-1.774-6.684 3.548.837.89.838 5.322 9.191 9.76 8.354z",
    id: "path6687",
    style: {
      fill: "#d91023",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.446 934.834s-47.074-4.545-48.595-16.948c-2.898-23.637 43.297-6.378 53.09-11.947 1.037-31.102-59.55-7.39-61.28-20.685-3.264-25.179 50.092-9.879 49.7-18.01-1.541-32.048-64.016-18.657-57.492-17.568",
    id: "path6689",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "asta__bandera_siniestra",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(50.537)",
    id: "rect25074",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M618.781-494.829h5.985v297.986h-5.985z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-3.28728 -1.03094 -1.06446 3.6188 2597.01 -1546.178)",
    id: "g25076",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25078",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.49 100.183l24.668 24.668-24.668 24.668-24.668-24.668 24.668-24.668z",
    transform: "matrix(-.11945 .07647 .17173 .22095 417.827 496.075)",
    id: "path25080",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 1.39543045,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.526 567.187l8.473 10.9-1.29-7.336-7.183-3.564z",
    id: "path25082",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.795 576.327c.815 0 1.475.635 1.475 1.42 0 .784-.66 1.42-1.475 1.42-.815 0-1.476-.636-1.476-1.42 0-.785.66-1.42 1.476-1.42z",
    id: "path25084",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 830.927 -30.51)",
    id: "pabellon_siniestra",
    style: {
      stroke: "#000",
      strokeWidth: 0.5,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6903",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6905",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-196.91 476.029h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6907",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-196.097 475.606h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6909",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-195.283 475.182h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6911",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-194.469 474.759h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6913",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-193.655 474.336h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6915",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-192.842 473.912h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6917",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-192.028 473.489h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6919",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-191.214 473.066h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6921",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-190.4 472.642h.8V492.5h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6923",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-189.587 472.219h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6925",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-188.773 471.796h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6927",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-187.959 471.372h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6929",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-187.145 470.949h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6931",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-186.331 470.526h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6933",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-185.518 470.102h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6935",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-184.704 469.679h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6937",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-183.89 469.255h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6939",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-183.076 468.832h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6941",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-182.263 468.409h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6943",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-181.449 467.985h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6945",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-180.635 467.562h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6947",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-179.821 467.139h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6949",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-179.007 466.715h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6951",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-178.194 466.292h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6953",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-177.38 465.869h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6955",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-176.566 465.445h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6957",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-175.752 465.022h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6959",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-174.939 464.599h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6961",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-174.125 464.175h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6963",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-173.311 463.752h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6965",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-172.497 463.329h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6967",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-171.684 462.905h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6969",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-170.87 462.482h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6971",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-170.056 462.059h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6973",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-169.242 461.635h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6975",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-168.428 461.212h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6977",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-167.615 460.789h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6979",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-166.801 460.365h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6981",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-165.987 459.942h.8V479.8h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6983",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-165.173 459.519h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6985",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-164.36 459.095h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6987",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-163.546 458.672h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6989",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-162.732 458.249h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6991",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-161.918 457.825h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6993",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-161.104 457.402h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6995",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-160.291 456.979h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6997",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-159.477 456.555h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6999",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-158.663 456.132h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7001",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-157.849 455.709h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7003",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-157.036 455.285h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7005",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-156.222 454.862h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7007",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-155.408 454.439h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7009",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-154.594 454.015h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7011",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-153.781 453.592h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7013",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-152.967 453.169h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7015",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-152.153 452.745h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7017",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-151.339 452.322h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7019",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-150.525 451.899h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7021",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-149.712 451.475h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7023",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-148.898 451.052h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7025",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-148.084 450.629h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7027",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-147.27 450.205h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7029",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-146.457 449.782h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7031",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-145.643 449.358h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7033",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-144.829 448.935h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7035",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-144.015 448.512h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7037",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-143.202 448.088h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7039",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-142.388 447.665h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7041",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-141.574 447.242h.8V467.1h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7043",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-140.76 446.818h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7045",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-139.946 446.395h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7047",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-139.133 445.972h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7049",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-138.319 445.548h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7051",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-137.505 445.125h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7053",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-136.691 444.702h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7055",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-135.878 444.278h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7057",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-135.064 443.855h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7059",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-133.436 443.008h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7061",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-132.623 442.585h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7063",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-131.809 442.162h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7065",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-130.995 441.738h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7067",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-130.181 441.315h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7069",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-129.367 440.892h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7071",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-128.554 440.468h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7073",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-127.74 440.045h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7075",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-126.926 439.622h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7077",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-126.112 439.198h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7079",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-125.299 438.775h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7081",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-124.485 438.352h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7083",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-123.671 437.928h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7085",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-122.857 437.505h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7087",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-122.043 437.082h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7089",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-121.23 436.658h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7091",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-120.416 436.235h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7093",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-119.602 435.812h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7095",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-134.25 443.432h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7097",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-118.788 435.388h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7099",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-117.975 434.965h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7101",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-117.161 434.542h.8V454.4h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7103",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-116.347 434.118h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7105",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-115.533 433.695h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7107",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-114.72 433.272h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7109",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-113.906 432.848h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7111",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-113.092 432.425h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7113",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-112.278 432.002h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7115",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-111.464 431.578h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7117",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-110.651 431.155h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7119",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-109.837 430.732h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7121",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-109.023 430.308h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7123",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-108.209 429.885h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7125",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-107.396 429.462h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7127",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-106.582 429.038h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7129",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-105.768 428.615h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7131",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-104.954 428.192h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7133",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-104.142 427.659h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7135",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-103.33 426.952h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7137",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-102.518 426.318h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7139",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-101.706 425.884h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7141",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-100.894 425.273h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7143",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-100.082 424.694h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7145",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-99.27 424.164h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7147",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-98.457 423.425h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7149",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-97.645 422.697h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7151",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-96.833 422.166h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7153",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-96.021 421.446h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7155",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-95.209 420.716h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7157",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-94.397 420.082h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7159",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-93.585 419.234h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7161",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-92.773 418.549h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7163",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-91.961 417.712h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7165",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-91.149 416.886h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7167",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-90.336 415.99h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7169",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-89.524 414.954h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7171",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-88.712 414.068h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7173",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-87.9 412.945h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7175",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-86.276 410.543h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7177",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-85.519 408.943h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7179",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-84.943 407.587h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7181",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-84.583 406.857h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7183",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-84.16 405.746h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7185",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-83.902 404.216h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7187",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-83.414 402.85h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect7189",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-87.088 411.854h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6907-1",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-197.724 476.452h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6915-4-2",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-207.489 481.532h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6917-8-1",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-206.676 481.109h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6919-8-6",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-205.862 480.686h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6921-2-8",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-205.048 480.262h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6923-4-5",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-204.234 479.839h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6925-5-7",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-203.421 479.416h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6927-5-6",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-202.607 478.992h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6929-1-1",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-201.793 478.569h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6931-7-8",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-200.979 478.146h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6933-1-9",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-200.166 477.722h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6935-1-2",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-199.352 477.299h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6937-5-7",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-198.538 476.876h.8v19.858h-.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M663.906 176.469l-.125.062s-68.079 60.537-121.406 99.125c-12.616 45.182 48.043 95.49 49.5 203.469 82.695-39.599 123.18-59.428 123.656-79.063.113.14.232.265.344.407L664.812 177.03l-.906-.562z",
    transform: "matrix(-1 0 0 1 798.927 2.268)",
    id: "path25064",
    style: {
      fill: "#d91023",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.406 252.781l-131.375 96.125 22.438 73.75L699.219 326l-16.813-73.219z",
    transform: "matrix(-1 0 0 1 800 0)",
    id: "path6703",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6721",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect6723",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M155.15 411.673h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6725",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M155.953 412.493h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6727",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M156.773 413.81h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6729",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M154.299 410.966h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6731",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M153.483 409.889h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6733",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M152.68 409.262h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6735",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M151.829 408.347h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6737",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M150.993 407.495h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6739",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M150.094 406.788h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6741",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M149.258 405.728h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6743",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M148.423 405.021h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6745",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M147.588 404.411h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6747",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M146.72 403.608h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6749",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M145.885 402.836h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6751",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M145.049 402.226h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6753",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M144.278 401.519h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6755",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M143.411 400.973h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6757",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M142.576 400.362h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6759",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M140.019 398.556h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6761",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M140.855 399.118h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6763",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M141.706 399.729h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6765",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M139.104 398.042h.8V417.9h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6767",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M138.288 397.51h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6769",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M137.517 397.012h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6771",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M136.698 396.514h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6773",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M135.927 395.888h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6775",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M135.091 395.534h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6777",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M134.288 395.085h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6779",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M133.485 394.603h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6781",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M132.682 394.121h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6783",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M131.878 393.767h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6785",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M131.011 393.253h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6787",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M130.111 392.932h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6789",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M129.276 392.579h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6791",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M128.473 392.129h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6793",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M127.669 391.872h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6795",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-89.396 396.791h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6797",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-88.56 397.289h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6799",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-87.709 398.156h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6801",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-90.215 396.212h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6803",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-90.998 395.328h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6805",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-91.834 394.862h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6807",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-92.717 394.492h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6809",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-93.552 393.641h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6811",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-115.232 388.315h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6813",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-116.022 388.436h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6815",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-116.835 388.638h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6817",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-94.406 393.162h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6819",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-95.182 392.632h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6821",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-95.972 392.178h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6823",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-96.762 391.75h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6825",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-97.579 391.406h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6827",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-98.446 390.997h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6829",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-99.282 390.568h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6831",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-101.747 389.806h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6833",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-100.912 390.005h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6835",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-100.106 390.297h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6837",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-102.617 389.474h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6839",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-103.478 389.215h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6841",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-104.385 389.081h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6843",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-105.296 388.81h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6845",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-106.112 388.683h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6847",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-108.754 388.318h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6849",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-109.568 388.277h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6851",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-110.383 388.216h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6853",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-111.197 388.188h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6855",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-111.978 388.21h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6857",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-112.8 388.207h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6859",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-113.654 388.249h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6861",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-114.467 388.259h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6863",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-117.796 388.81h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6865",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-118.664 389.002h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6867",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-121.184 389.501h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6869",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-120.317 389.26h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6871",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-119.497 389.099h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6873",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-122.036 389.693h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6875",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-122.819 389.933h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6877",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-123.622 390.206h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6879",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-124.441 390.415h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6881",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-125.277 390.752h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6883",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-126.08 390.977h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6885",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-126.883 391.202h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6887",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-127.686 391.588h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6889",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-107.872 388.423h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6891",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-107.042 388.502h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6893",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-83.488 402.347h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6895",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-84.272 401.687h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6897",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-85.075 400.675h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6899",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-85.926 399.759h.8v19.858h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1)",
    id: "rect6901",
    style: {
      fill: "#eac102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M-86.762 398.908h.8v19.858h-.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M685.44 145.479c-15.04 62.796-10.319 170.539-22.818 233.8 19.602-22.227 52.646-37.23 73.881-10.364L685.441 145.48z",
    transform: "matrix(-1 0 0 1 819.542 33.835)",
    id: "path6707",
    style: {
      fill: "#d91023",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.031 248.969c-.356-.007-.704.017-1.062.031-6.525.262-13.273 3.845-20.125 6.75-1.245 17.701-2.224 35.95-3.219 54-.065 1.186-.122 2.378-.188 3.562-.07 1.306-.147 2.604-.218 3.907-.277 5.088-.575 10.144-.875 15.156 8.387-16.298 37.294-15.367 47.343-9.063a1462.13 1462.13 0 0 1-6.78-32.156c-4.698-20.553-5.272-23.031-9.407-41.125-1.805-.712-3.62-1.029-5.469-1.062z",
    transform: "matrix(-1 0 0 1 798.927 2.268)",
    id: "path6709",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "asta_pabell\\xF3n_siniestra",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1) rotate(50.537)",
    id: "rect25072",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "M49.715 215.733H55.7v297.986h-5.985z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.28728 -1.03094 1.06446 3.6188 -1686.743 -1533.904)",
    id: "g6711",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6713",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.49 100.183l24.668 24.668-24.668 24.668-24.668-24.668 24.668-24.668z",
    transform: "matrix(-.11945 .07647 .17173 .22095 417.827 496.075)",
    id: "path6715",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 1.39543045,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.526 567.187l8.473 10.9-1.29-7.336-7.183-3.564z",
    id: "path6717",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.795 576.327c.815 0 1.475.635 1.475 1.42 0 .784-.66 1.42-1.475 1.42-.815 0-1.476-.636-1.476-1.42 0-.785.66-1.42 1.476-1.42z",
    id: "path6719",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.27742073,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }))))), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1 0 0 1 840 0)",
    id: "pabellon_diestro",
    style: {
      stroke: "#000",
      strokeWidth: 0.5,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 800,
    height: 935,
    xlinkHref: "#pabellon_siniestra"
  })), /*#__PURE__*/React.createElement("g", {
    id: "timbre"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.44722 -.20656 .2582 .35777 89.404 -67.294)",
    id: "palma_siniestra",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stam",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.212 566.87c31.28 33.04 62.37 68.152 78.925 111.21 25.21 69.711 18.346 151.527-22.518 213.983-34.388 51.789-85.32 91.514-141.97 116.401-51.945 21.524-112.113 23.773-164.827 3.54-20.114-7.373-38.889-17.914-57.51-28.315-8.441-1.44-13.874 8.648-6.988 13.292 62.35 40.624 130.86 42.249 202.053 28.197 36.106-9.534 69.76-27.273 98.991-50.401 44.36-33.229 82.625-77.439 99.76-130.902 26.131-78.994 9.286-171.344-45.167-234.649-13.723-16.785-28.875-32.351-44.687-47.168l3.938 4.813z",
    id: "path4454",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.57 983.29c-8.079-.843-12.167 11.815-5.077 13.643 4.182-1.01 10.665-12.011 5.076-13.642z",
    id: "path4456",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2961",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.835 552.405c-4.503-5.593-14.062-2.886-17.759-7.3-3.94-4.706 2.887-6.51-.226-9.991-3.113-3.48-7.746-1.747-11.998-6.498-4.251-4.75-.422-8.776-4.09-12.099-3.667-3.322-4.171.887-8.372-3.724-4.2-4.612-1.717-12.71-6.304-18.558-4.481-5.712-2.984-12.5 2.496-11.257 3.644.826 5.064 4.385 10.468 5.756 5.404 1.372 7.577-2.577 11.118.904 3.542 3.481.308 9.122 4.105 13.971 3.798 4.85 5.83 1.303 8.515 5.626 2.686 4.323.5 6.61 2.228 11.666 1.729 5.056 8.377 3.105 10.869 10.748 2.492 7.643-1.05 20.756-1.05 20.756z",
    id: "path30661",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.146 564.793c-5.561-26.182-26.97-56.915-52.595-79.474 15.222 11.956 44.848 40.53 54.361 79.28l-1.766.194z",
    id: "path30663",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.18 524.426c-4.162-2.885-7.254-2.85-10.507-3.257 2.963-.163 5.873-.472 9.492 1.156l1.014 2.101z",
    id: "path30665",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.001 505.477c-4.502-1.455-7.443-.392-10.62.29 2.794-1.147 5.51-2.419 9.262-2.021l1.358 1.73z",
    id: "path30667",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.378 508.855c-2.195-5.54-2.198-9.678-2.533-14.028-.094 3.967-.298 7.863.952 12.69l1.58 1.338z",
    id: "path30669",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.899 527.04c-2.195-5.54-2.198-9.677-2.533-14.027-.094 3.966-.298 7.863.953 12.69l1.58 1.338z",
    id: "path30671",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2981",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.176 682.062c-8.257-3.177-17.17-.031-23.877-2.453-7.148-2.582 1.14-8.575-4.41-10.366-5.548-1.79-10.208 5.644-17.785 3.202-7.578-2.442-6.322-10.125-12.54-11.417-6.218-1.291-6.37 7.191-13.822 4.865-7.453-2.327-7.5-12.33-15.974-15.724-8.276-3.314-9.088-11.348-1.33-13.33 5.16-1.318 10.29 1.936 18.002.135s6.976-8.643 13.093-7.11c6.116 1.535 4.355 10.427 11.373 13.246 7.017 2.818 11.366-4.905 16.697-1.972 5.33 2.932.26 9.424 4.625 13.701 4.367 4.277 7.736-2.34 14.176 4.2 6.44 6.538 11.772 23.023 11.772 23.023z",
    id: "path30715",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.504 691.584c-22.904-25.577-58.656-41.392-101.83-49.728 25.052 3.433 76.71 14.954 105.234 49.976l-3.404-.248z",
    id: "path30717",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.282 661.447c-6.69-.536-10.766 1.355-15.236 2.88 3.851-1.95 7.573-4.02 13.029-4.48l2.207 1.6z",
    id: "path30719",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.411 650.636c-6.554 1.172-10.006 4.054-13.927 6.677 3.224-2.882 6.292-5.848 11.419-7.682l2.508 1.005z",
    id: "path30721",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.589 651.561c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.841 8.443 6.48 12.767l2.64.458z",
    id: "path30723",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.954 662.563c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.84 8.443 6.48 12.767l2.64.458z",
    id: "path30725",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4564",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.74 885.605c6.924-5.379 9.128-14.933 14.625-19.391 5.859-4.753 6.268 5.877 10.646 2.066 4.377-3.81.889-12.104 6.864-17.31 5.974-5.206 11.467.264 15.799-4.413 4.332-4.678-2.387-9.643 3.43-14.807 5.815-5.163 13.859.495 21.071-4.949 7.045-5.317 13.915-1.447 11.39 6.438-1.679 5.243-7.007 7.856-9.652 15.597-2.645 7.74 3.23 10.999-1.243 15.45-4.472 4.452-10.667-2.148-16.646 2.356-5.98 4.504-2.095 12.69-7.272 15.661-5.177 2.97-7.692-5.144-13.435-3.78-5.743 1.366-2.226 8.069-10.882 9.95-8.655 1.883-24.696-2.868-24.696-2.868z",
    id: "path30793",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.691 887.43c32.645-5.369 64.277-27.486 93.849-60.328-16.034 19.857-52.657 58.27-95.853 63.151l2.004-2.822z",
    id: "path30795",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.643 870.452c3.977-5.52 4.621-10.146 5.77-14.907-.48 4.464-.794 8.885-3.317 13.897l-2.453 1.01z",
    id: "path30797",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.085 852.345c2.535-6.374 2.056-11.022 2.032-15.93.6 4.448 1.352 8.81.103 14.318l-2.135 1.612z",
    id: "path30799",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.538 858.067c6.36-1.944 10.75-.953 15.437-.406-4.187-1.095-8.275-2.337-13.67-1.631l-1.767 2.037z",
    id: "path30801",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.271 873.884c6.36-1.945 10.75-.954 15.437-.406-4.187-1.096-8.275-2.337-13.67-1.632l-1.767 2.038z",
    id: "path30803",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.961 -12.093)",
    id: "g3009",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.54 802.033c5.85-6.618 6.32-16.43 10.93-21.87 4.915-5.797 7.205 4.57 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.332 4.947-6.265 11.317-1.945 14.743-7.375 3.427-5.43-4.058-9.018.742-15.211 4.799-6.193 13.709-2.18 19.83-8.916 5.98-6.58 13.42-4.098 12.338 4.136-.72 5.476-5.492 9.068-6.717 17.184-1.225 8.116 5.127 10.188 1.522 15.423-3.605 5.235-10.865-.06-15.942 5.516-5.077 5.577.195 12.875-4.366 16.79-4.56 3.915-8.473-3.576-13.875-1.13-5.402 2.445-.755 8.357-8.927 11.87-8.173 3.515-24.78 1.931-24.78 1.931z",
    id: "path30805",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.023 806.144c31.13-11.555 58.291-39.374 81.522-77.336-12.232 22.597-41.404 67.391-82.99 80.495l1.468-3.159z",
    id: "path30807",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.187 780.813c2.928-6.19 2.74-10.86 3.023-15.76.322 4.48.798 8.885-.792 14.296l-2.23 1.464z",
    id: "path30809",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.011 758.51c1.36-6.752.063-11.227-.832-16.046 1.38 4.256 2.893 8.399 2.644 14.052l-1.812 1.994z",
    id: "path30811",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.558 765.009c5.906-3.135 10.395-3.005 15.1-3.368-4.31-.272-8.548-.706-13.725 1.025l-1.375 2.343z",
    id: "path30813",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.483 784.834c5.905-3.134 10.395-3.004 15.099-3.367-4.309-.272-8.547-.706-13.725 1.025l-1.374 2.342z",
    id: "path30815",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3037",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.287 741.198c-7.882-5.63-18.267-4.844-24.713-9.25-6.871-4.697 3.657-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.841-12.336-10.09-15.426-6.25-3.09-8.83 5.718-16.099 1.202s-4.466-14.966-12.516-20.881c-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.12 5.186 8.722.281 5.015-4.332 11.087-1.017 6.073 3.314 4.839 12.095 11.504 17.002 6.665 4.907 15.195-4.66 20.032-.107 4.837 4.554-2.411 9.907 1.016 15.593s8.9-.273 13.89 8.353c4.99 8.627 5.963 27.322 5.963 27.322z",
    id: "path30817",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.434 753.467c-17.083-33.105-50.623-59.625-94.197-80.421 25.684 10.602 77.379 37.099 97.75 81.634l-3.553-1.213z",
    id: "path30819",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.285 711.031c-6.968-2.434-11.845-1.602-17.038-1.264 4.656-.955 9.207-2.073 15.145-1.024l1.893 2.288z",
    id: "path30821",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.705 691.94c-7.31-.612-11.806 1.427-16.727 3.065 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75z",
    id: "path30823",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.08 694.918c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.68 1.218z",
    id: "path30825",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.939 713.505c-4.23-6.155-4.807-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218z",
    id: "path30827",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3065",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.02 750.362c4.442-7.713 2.994-17.422 6.451-23.72 3.685-6.712 7.945 2.959 10.603-2.297 2.659-5.256-3.596-11.547.03-18.725 3.628-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.232-15.052 3.495-7.076 13.002-5.022 17.686-12.908 4.577-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.651 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506-7.32 5.162-23.893 7.11-23.893 7.11z",
    id: "path30829",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.541 756.813c28.24-17.872 49.428-50.836 64.795-92.905-7.584 24.705-27.44 74.716-65.618 96.309l.823-3.404z",
    id: "path30831",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.927 723.337c1.664-6.678.572-11.212-.104-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904z",
    id: "path30833",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.003 697.32c.019-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335z",
    id: "path30835",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.886 704.411c5.174-4.313 9.596-5.132 14.132-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583z",
    id: "path30837",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.06 727.844c5.175-4.313 9.597-5.132 14.133-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583z",
    id: "path30839",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3093",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.393 638.911c3.616-8.648.844-18.542 3.621-25.58 2.96-7.5 8.651 1.957 10.732-3.884 2.081-5.842-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.715-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.951-8.855 13.596-.309 1.094 5.685-2.453 10.95-.99 19.43 1.463 8.482 8.444 8.267 6.597 14.743-1.847 6.476-10.791 3.821-13.985 11.162-3.194 7.34 4.44 12.69 1.211 18.2-3.23 5.508-9.58-.518-14.13 3.835-4.548 4.354 2.01 8.552-4.934 14.954-6.943 6.403-23.931 10.765-23.931 10.765z",
    id: "path30841",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.331 647.1c27.05-22.572 44.8-59.846 55.309-105.768-4.672 26.765-18.816 81.581-55.722 109.423l.413-3.656z",
    id: "path30843",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.785 607.29c.86-7.18-.866-11.741-2.202-16.699 1.796 4.326 3.722 8.52 3.931 14.452l-1.73 2.247z",
    id: "path30845",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.08 578.105c-.879-7.177-3.64-11.15-6.118-15.606 2.772 3.725 5.64 7.29 7.257 12.982l-1.138 2.624z",
    id: "path30847",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.801 585.779c4.821-5.216 9.315-6.69 13.859-8.731-4.361 1.27-8.707 2.353-13.268 5.918l-.59 2.813z",
    id: "path30849",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43 612.242c4.821-5.216 9.315-6.691 13.859-8.731-4.362 1.27-8.707 2.353-13.269 5.918l-.59 2.813z",
    id: "path30851",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3193",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.383 605.314c4.26-6.586-1.069-18.724 2.254-24.109 3.541-5.739 7.22 2.947 9.785-1.556 2.564-4.504-.434-10.335 3.065-16.486 3.5-6.15 8.534-1.658 10.788-6.866 2.254-5.208-2.035-5.336 1.341-11.402 3.377-6.067 12.051-3.846 16.538-10.574 4.383-6.571 11.49-5.472 11.791 1.839.2 4.863-2.913 7.166-2.76 14.395.152 7.229 4.65 9.567 2.204 14.63-2.446 5.064-8.907 1.554-12.63 7.124-3.723 5.57.338 7.774-3.175 11.827-3.514 4.052-6.377 1.487-10.88 4.382-4.502 2.895-.728 11.329-7.568 15.547s-20.753 1.249-20.753 1.249z",
    id: "path30855",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.094 611.2c24.26-10.566 48.596-42.396 63.7-78.703-7.548 21.385-27.469 63.674-63.017 80.985l-.683-2.282z",
    id: "path30857",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.883 582.647c1.686-5.797.792-9.83.287-14.13.986 3.85 2.1 7.61 1.503 12.54l-1.79 1.59z",
    id: "path30859",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.338 560.438c.18-6.063-1.686-9.768-3.242-13.83 1.908 3.503 3.918 6.889 4.57 11.838l-1.328 1.992z",
    id: "path30861",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.226 566.578c4.85-3.565 8.928-4.091 13.122-5.077-3.936.378-7.833.604-12.243 2.845l-.88 2.232z",
    id: "path30863",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.063 586.528c4.85-3.566 8.928-4.092 13.123-5.077-3.936.377-7.834.603-12.244 2.845l-.879 2.232z",
    id: "path30865",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.102 5.758)",
    id: "g3207",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.89 1006.515c3.57-9.036.932-19.719 3.674-27.08 2.924-7.845 8.404 2.52 10.463-3.602 2.059-6.12-5.035-12.522-2.227-20.881 2.808-8.359 10.325-5.832 11.926-12.792 1.602-6.96-6.763-8.331-4.076-16.564 2.688-8.232 12.564-6.874 16.358-16.127 3.706-9.039 11.679-8.838 13.228.354 1.03 6.113-2.452 11.546-1.078 20.658 1.373 9.112 8.165 9.234 6.33 16.043-1.835 6.809-10.52 3.53-13.67 11.193-3.15 7.663 4.245 13.748 1.07 19.457-3.174 5.71-9.316-1.032-13.766 3.38-4.451 4.411 1.903 9.215-4.889 15.69-6.792 6.474-23.343 10.271-23.343 10.271z",
    id: "path31006",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.319 1010.66c26.447-22.698 40.669-57.455 51.162-105.87-4.703 28.291-15.52 81.925-51.586 109.745l.424-3.875z",
    id: "path31008",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.86 973.939c.88-7.61-.774-12.557-2.044-17.908 1.722 4.7 3.57 9.267 3.738 15.599l-1.695 2.309z",
    id: "path31010",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.993 943.452c-.814-7.694-3.477-12.066-5.86-16.94 2.675 4.11 5.442 8.053 6.983 14.2l-1.123 2.74z",
    id: "path31012",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.702 951.565c4.72-5.316 9.101-6.663 13.533-8.61-4.25 1.135-8.483 2.072-12.942 5.642l-.59 2.968z",
    id: "path31014",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.512 979.148c4.72-5.317 9.1-6.664 13.533-8.61-4.25 1.135-8.484 2.071-12.942 5.641l-.591 2.969z",
    id: "path31016",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3237",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.082 832.168c-7.131-7.46-19.244-10.076-25.142-16.004-6.287-6.318 7.034-6.423 2.01-11.151-5.023-4.73-15.242-1.31-22.104-7.764-6.862-6.454-.297-12.072-6.405-16.78-6.11-4.707-11.974 2.218-18.774-4.068-6.8-6.286-.138-14.585-7.367-22.35-7.06-7.585-2.579-14.703 7.456-11.801 6.675 1.93 10.246 7.624 20.107 10.648 9.861 3.025 13.63-3.063 19.462 1.785 5.833 4.849-2.112 11.171 3.87 17.609 5.98 6.438 16.044 2.598 20.056 8.142 4.013 5.545-6.035 7.945-4.007 14.037 2.027 6.092 10.249 2.594 13.085 11.77 2.837 9.176-2.247 25.927-2.247 25.927z",
    id: "path31042",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.258 797.04c-7.147-4.36-12.989-5.181-19.028-6.537 5.63.643 11.196 1.109 17.626 3.922l1.402 2.614z",
    id: "path31046",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.245 771.787c-8.14-2.867-13.947-2.505-20.108-2.63 5.552-.496 10.986-1.153 17.968.331l2.14 2.299z",
    id: "path31048",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.677 776.753c-2.79-6.76-1.786-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924z",
    id: "path31050",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.75 800.697c-2.789-6.76-1.785-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924z",
    id: "path31052",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.704 840.054c-8.529-34.554-35.695-63.696-78.54-95.86 25.804 17.503 73.699 52.404 82.193 98.058l-3.653-2.198z",
    id: "path31044",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3115",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.296 890.544c-3.353-8.85-19.798-13.112-22.673-20.186-3.064-7.54 9.126-5.225 6.542-10.926-2.584-5.701-13.345-4.096-16.877-11.879-3.532-7.782 4.826-12.277 1.244-18.154-3.583-5.876-11.854.07-15.4-7.532-3.547-7.6 6.031-14.792 2.719-23.969-3.235-8.964 3.857-15.356 11.781-10.593 5.271 3.167 6.123 9.582 13.838 14.436 7.715 4.855 13.721-.624 16.993 5.346 3.271 5.97-6.643 10.926-3.907 18.532 2.736 7.606 13.533 5.547 14.85 11.89 1.318 6.344-8.857 6.948-9.58 13.485-.724 6.537 8.25 4.488 6.962 14.295-1.288 9.807-6.492 25.255-6.492 25.255z",
    id: "path30673",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.011 853.111c-4.675-5.713-13.031-8.939-17.965-11.41 4.862 1.675 13.116 4.49 17.792 8.508l.173 2.902z",
    id: "path30675",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.082 828.225c.311-7.352 3.166-11.82 5.636-16.725-2.893 4.223-5.912 8.302-7.244 14.293l1.608 2.432z",
    id: "path30679",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.503 854.289c.311-7.352-.15-9.81 2.32-14.714-2.892 4.222-2.596 6.292-3.928 12.283l1.608 2.431z",
    id: "path30681",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.2 906.633c6.813-36.538-12.825-78.385-38.311-118.74 16.138 22.413 52.245 73.859 40.713 121.63l-2.402-2.89z",
    id: "path30683",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.403 821.845c-6.213-4.382-11.66-5.071-17.225-6.319 5.271.507 10.504.83 16.244 3.602l.98 2.717z",
    id: "path30677",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3251",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.56 566.123c-1.927-7.016-11.717-8.589-13.368-14.187-1.76-5.967 5.18-4.726 3.698-9.223-1.483-4.498-6.394-4.876-8.42-11.015-2.028-6.14 3.044-8.197.993-12.785-2.052-4.588-4.158-.956-6.193-6.947-2.035-5.99 3.4-12.339 1.494-19.622-1.861-7.115 2.16-12.683 6.68-9.229 3.006 2.298 2.912 6.15 7.313 9.69 4.4 3.541 7.928.853 9.803 5.533 1.875 4.68-3.284 8.464-1.71 14.502 1.573 6.037 4.815 3.657 5.578 8.743.764 5.087-2.126 6.251-2.523 11.602-.398 5.35 6.438 6.382 5.727 14.42-.71 8.037-9.071 18.518-9.071 18.518z",
    id: "path31054",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.743 578.842c5.153-26.274-2.39-63.414-16.983-94.87 9.233 17.366 25.128 56.012 18.673 95.44l-1.69-.57z",
    id: "path31056",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.108 534.358c-2.673-4.397-5.511-5.675-8.324-7.424 2.77 1.106 5.55 2.055 8.219 5.074l.105 2.35z",
    id: "path31058",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.65 510.62c-3.545-3.235-6.647-3.508-9.815-4.23 3 .135 5.978.123 9.25 2.074l.565 2.157z",
    id: "path31060",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.327 515.56c.16-5.991 1.774-9.773 3.169-13.888-1.636 3.584-3.345 7.057-4.09 11.996l.92 1.892z",
    id: "path31062",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.57 537.898c.16-5.991 1.775-9.773 3.17-13.888-1.637 3.583-3.346 7.057-4.09 11.996l.92 1.892z",
    id: "path31064",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3271",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.672 575.22c-.207-6.888-6.92-11.393-7.205-16.889-.304-5.858 14.644-4.381 14.25-8.797-.392-4.416-5.461-4.804-6.001-10.832-.54-6.028 5.332-8.027 4.364-12.534-.968-4.506-4.128-.952-4.714-6.834-.586-5.883 1.959-12.396 1.845-19.545-.112-6.984 5.565-12.43 9.425-9.027 2.567 2.264 1.468 6.042 5.18 9.53 3.712 3.486 8.359.996 11.29 4.523 2.915 3.507 2.309 6.345 2.397 12.272.09 5.926 4.118 3.603 3.602 8.594-.517 4.99-3.861 6.123-5.668 11.368-1.807 5.246 5.12 6.282 2.285 14.161-2.835 7.88-31.05 24.01-31.05 24.01z",
    id: "path31066",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.22 585.584c24.422-21.57 36.501-63.212 18.317-93.996 8.18 15.13 12.468 31.125 8.112 50.275-3.15 13.846-10.823 30.446-24.8 44.286l-1.63-.565z",
    id: "path31068",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.267 550.763c-1.672-4.322-6.172-9.786-8.678-11.51 2.628 1.093 7.152 6.235 9.177 9.205l-.499 2.305z",
    id: "path31070",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.287 523.946c-2.89-3.185-6.084-3.465-9.23-4.183 3.121.143 6.259.14 9.196 2.066l.034 2.117z",
    id: "path31072",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.441 524.146c1.724-5.874 4.405-9.577 6.94-13.608-2.652 3.509-5.352 6.91-7.417 11.75l.477 1.858z",
    id: "path31074",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.17 551.67c1.723-5.874 7.855-3.776 12.463-5.225-3.495.052-10.876-1.474-12.942 3.368l.478 1.857z",
    id: "path31076",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3285",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.903 575.873c-6.493-4.618-4.563-15.69-9.703-19.496-5.479-4.057-6.718 3.84-10.79.614-4.074-3.225-2.685-8.63-8.243-13.035-5.56-4.406-9.503.287-13.463-3.581-3.96-3.868.525-4.807-4.88-9.168-5.403-4.36-13.875-.838-20.651-5.53-6.62-4.581-13.78-2.292-11.875 3.812 1.267 4.06 5.25 5.359 7.286 11.366 2.037 6.006-1.995 8.813 2.123 12.525 4.118 3.712 9.864-.446 15.482 3.436 5.619 3.882 2.006 6.494 6.943 9.162 4.937 2.668 7.176-.009 12.804 1.51 5.627 1.519 4.21 9.225 12.706 11.384 8.495 2.16 22.261-2.999 22.261-2.999z",
    id: "path31078",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.596 578.547c-28.791-4.023-64.127-25.614-91.088-52.699 14.459 16.215 48.316 47.311 91.062 54.718l.026-2.02z",
    id: "path31080",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.235 561.697c-3.54-4.466-3.822-7.974-4.597-11.627.13 3.374.099 6.7 2.227 10.66l2.37.967z",
    id: "path31082",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.243 546.142c-2.033-4.978-1.192-8.404-.785-12.065-.947 3.267-2.037 6.457-1.22 10.676l2.005 1.389z",
    id: "path31084",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.337 550.809c-6.199-2.006-10.658-1.649-15.38-1.649 4.264-.452 8.443-1.023 13.774-.026l1.606 1.675z",
    id: "path31086",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.334 564.552c-6.199-2.005-10.658-1.648-15.38-1.648 4.264-.453 8.443-1.023 13.774-.027l1.606 1.675z",
    id: "path31088",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3299",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.517 605.577c-8.06-3.492-6.615-15.421-13.007-18.344-6.814-3.114-7.68 5.366-12.762 2.833-5.082-2.534-3.845-8.447-10.78-11.909-6.936-3.461-11.258 2.23-16.254-.997-4.996-3.226.255-5.115-6.493-8.56-6.748-3.446-16.535 1.944-24.936-1.567-8.207-3.43-16.533.41-13.805 6.384 1.815 3.972 6.641 4.517 9.518 10.363 2.876 5.845-1.695 9.59 3.476 12.62 5.172 3.032 11.675-2.469 18.64.435 6.966 2.905 2.878 6.36 8.942 8.137 6.064 1.777 8.517-1.468 15.313-1.028 6.796.44 5.704 8.758 15.953 9.281 10.248.524 26.195-7.648 26.195-7.648z",
    id: "path31090",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.976 605.581c-34.484 1.658-78.077-13.661-112.15-36.407 18.4 13.96 60.967 39.483 112.273 38.517l-.123-2.11z",
    id: "path31092",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.843 597.24c-4.542-3.935-5.146-7.533-6.345-11.182.413 3.488.63 6.96 3.458 10.655l2.887.527z",
    id: "path31094",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.55 585.499c-2.794-4.774-2.057-8.516-1.853-12.413-.875 3.597-1.925 7.142-.634 11.373l2.487 1.04z",
    id: "path31096",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 589.53c-7.51-.83-12.777.447-18.383 1.407 5.028-1.338 9.945-2.782 16.35-2.826l2.033 1.419z",
    id: "path31098",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.74 599.585c-7.511-.83-12.777.447-18.383 1.407 5.028-1.338 9.944-2.781 16.35-2.826l2.033 1.419z",
    id: "path31100",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3313",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.502 629.672c-8.279-2.962-7.618-14.951-14.193-17.452-7.009-2.666-7.318 5.846-12.559 3.648-5.24-2.198-4.393-8.174-11.546-11.178-7.152-3.004-11.095 2.95-16.296.055-5.2-2.894-.08-5.117-7.045-8.117-6.965-3-16.384 3.007-25.005.048-8.42-2.89-16.482 1.477-13.366 7.257 2.073 3.844 6.928 4.076 10.184 9.72 3.255 5.643-1.063 9.67 4.3 12.36 5.363 2.688 11.496-3.216 18.642-.77 7.147 2.446 3.291 6.155 9.463 7.536 6.172 1.38 8.409-2.014 15.224-2.014 6.816-.001 6.27 8.364 16.539 8.225 10.269-.14 25.658-9.318 25.658-9.318z",
    id: "path31102",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.937 628.613c-34.327 3.88-78.864-8.58-114.381-29.062 19.291 12.731 63.471 35.434 114.642 31.158l-.261-2.096z",
    id: "path31104",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.335 623.855c-4.795-3.63-5.633-7.179-7.07-10.74.641 3.452 1.085 6.9 4.152 10.402l2.918.338z",
    id: "path31106",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.31 613.91c-3.104-4.58-2.613-8.359-2.666-12.258-.637 3.643-1.453 7.247.114 11.382l2.552.876z",
    id: "path31108",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.782 617.593c-7.554-.344-12.73 1.271-18.264 2.59 4.933-1.66 9.748-3.416 16.14-3.874l2.124 1.284z",
    id: "path31110",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.38 625.942c-7.555-.343-12.73 1.271-18.265 2.59 4.933-1.659 9.748-3.415 16.14-3.874l2.124 1.284z",
    id: "path31112",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3165",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.197 997.382c6.594-4.258 15.187-3.229 20.577-6.552 5.746-3.542-2.93-7.124 1.577-9.691 4.508-2.568 10.299 2.924 16.456-.579s3.323-9.842 8.535-12.107c5.212-2.265 7.249 4.965 13.322 1.584 6.072-3.38 3.87-11.948 10.607-16.432 6.58-4.38 5.496-11.406-1.813-11.654-4.862-.166-8.671 3.576-15.899 3.473-7.227-.103-8.111-6.094-13.18-3.641-5.068 2.453-1.515 9.734-7.092 13.454-5.577 3.72-11.157-2.076-15.216 1.427-4.06 3.503 1.884 8.112-1.02 12.586s-7.37-.559-11.601 6.237c-4.233 6.796-5.253 21.895-5.253 21.895z",
    id: "path30958",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.964 1007.083c14.53-26.156 42.618-46.357 78.95-61.542-21.397 7.61-64.522 27.103-81.906 62.39l2.956-.848z",
    id: "path30960",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.91 973.981c5.8-1.706 9.83-.848 14.128-.377-3.846-.95-7.603-2.027-12.534-1.404l-1.594 1.781z",
    id: "path30962",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.146 959.533c6.062-.22 9.763 1.602 13.82 3.115-3.498-1.864-6.878-3.83-11.826-4.443l-1.994 1.327z",
    id: "path30964",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.003 961.663c3.575-4.823 4.11-8.86 5.104-13.017-.386 3.897-.62 7.754-2.87 12.133l-2.234.884z",
    id: "path30966",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.026 975.808c3.575-4.823 4.11-8.86 5.105-13.017-.386 3.896-.62 7.754-2.871 12.132l-2.234.885z",
    id: "path30968",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3179",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.31 1024.483c9.07 3.59 19.283 0 26.659 2.74 7.86 2.916-1.833 9.73 4.283 11.752 6.117 2.023 11.83-6.42 20.182-3.663 8.353 2.757 6.447 11.475 13.346 12.93 6.9 1.455 7.619-8.17 15.839-5.544 8.22 2.627 7.627 13.976 16.924 17.811 9.081 3.746 9.475 12.86.633 15.122-5.88 1.505-11.432-2.178-20.209-.12-8.777 2.057-8.393 9.818-15.164 8.089-6.77-1.73-4.218-11.822-11.918-15.007-7.7-3.185-13.082 5.584-18.88 2.267-5.797-3.318.317-10.693-4.31-15.538-4.628-4.844-8.839 2.668-15.65-4.738-6.81-7.407-11.734-26.101-11.734-26.101z",
    id: "path30691",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.572 1013.693c24.073 28.978 63.205 46.859 111.156 56.24-27.914-3.851-85.188-16.83-114.963-56.515l3.807.275z",
    id: "path30693",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.677 1047.816c7.48.597 12.179-1.557 17.298-3.294-4.452 2.218-8.765 4.574-14.923 5.107l-2.375-1.812z",
    id: "path30695",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.281 1060.033c7.437-1.342 11.5-4.618 16.073-7.601-3.807 3.275-7.445 6.647-13.32 8.736l-2.753-1.135z",
    id: "path30697",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28 1058.996c5.53 5.104 7.165 10.033 9.39 14.989-1.42-4.792-2.646-9.575-6.455-14.474l-2.935-.515z",
    id: "path30699",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.502 1046.558c5.53 5.104 7.166 10.034 9.39 14.99-1.42-4.793-2.646-9.575-6.454-14.475l-2.936-.515z",
    id: "path30701",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("use", {
    transform: "translate(43.941 17.372)",
    id: "use4482",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g3165"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(59.27 11.24)",
    id: "use4484",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g3179"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3137",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.525 1034.119c9.75.938 18.788-5.287 26.67-4.699 8.403.627.695 9.792 7.17 10.044 6.474.252 9.888-9.375 18.729-9.035 8.84.34 9.205 9.186 16.298 8.681 7.093-.504 5.34-9.89 14.018-9.638 8.679.252 10.993 11.25 21.029 12.36 9.802 1.084 12.508 9.676 4.47 14.262-5.345 3.05-11.693 1.057-19.72 5.43-8.027 4.371-5.676 11.676-12.713 11.882-7.037.207-7.122-10.128-15.435-11.056-8.314-.928-11.323 8.921-17.817 7.345-6.494-1.576-2.416-10.294-8.16-13.65-5.743-3.355-7.93 4.972-16.454-.23-8.524-5.202-18.085-21.696-18.085-21.696z",
    id: "path30769",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.262 1026.217c30.838 21.058 73.521 27.39 122.63 23.187-28.178 3.984-87.287 7.308-126.41-22.406l3.78-.781z",
    id: "path30771",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.98 1047.238c7.44-1.483 11.469-4.828 16.014-7.891-3.772 3.34-7.374 6.772-13.238 8.97l-2.776-1.078z",
    id: "path30773",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.91 1050.503c6.904-3.321 10.028-7.563 13.723-11.666-2.874 4.171-5.56 8.388-10.751 11.995l-2.971-.329z",
    id: "path30775",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.85 1051.709c6.689 3.355 9.539 7.612 12.969 11.732-2.605-4.185-5.018-8.414-9.977-12.046l-2.992.314z",
    id: "path30777",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.618 1047.457c6.688 3.355 9.538 7.612 12.968 11.733-2.605-4.185-5.018-8.415-9.977-12.046l-2.991.313z",
    id: "path30779",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3335",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.72 1024.547c4.983-5.068 13.172-6.262 17.286-10.274 4.385-4.277-4.539-5.162-1.043-8.344 3.495-3.182 10.25-.04 15.024-4.383 4.775-4.342.528-8.882 4.75-11.982 4.222-3.1 7.963 2.36 12.692-1.861 4.728-4.222.49-10.745 5.546-16.031 4.939-5.164 2.13-10.684-4.674-9.153-4.526 1.019-7.074 5-13.765 6.632-6.69 1.631-9.05-3.085-13.09.136-4.042 3.22 1.11 8.363-3.074 12.747-4.184 4.383-10.823.942-13.663 4.787-2.84 3.844 3.828 6.223 2.303 10.591-1.525 4.369-6.939 1.29-9.09 7.884-2.152 6.593.798 19.25.798 19.25z",
    id: "path30982",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.089 1030.323c6.657-24.958 25.657-44.795 55.246-65.91-17.769 11.34-50.817 34.166-57.754 67.31l2.508-1.4z",
    id: "path30984",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.634 999.911c4.908-2.78 8.845-3.032 12.929-3.665-3.79.132-7.533.139-11.919 1.822l-1.01 1.843z",
    id: "path30986",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.414 982.75c5.533-1.62 9.415-1 13.547-.72-3.707-.702-7.33-1.516-12.05-.845l-1.497 1.565z",
    id: "path30988",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.298 985.96c2.054-4.814 1.507-8.261 1.352-11.915.649 3.296 1.427 6.523.48 10.658l-1.832 1.258z",
    id: "path30990",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.523 1002.335c2.054-4.814 1.507-8.262 1.353-11.915.648 3.295 1.426 6.523.479 10.658l-1.832 1.257z",
    id: "path30992",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3349",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.42 1017.313c4.024-6.249 12.081-9.145 15.439-14.127 3.579-5.31-5.644-4.413-2.745-8.41 2.898-3.998 10.379-2.124 14.34-7.58 3.96-5.457-1.262-9.286 2.39-13.347 3.651-4.06 8.547.823 12.485-4.5 3.938-5.323-1.676-11.202 2.378-17.692 3.96-6.34-.004-11.472-6.59-8.508-4.38 1.971-6.157 6.603-12.608 9.647-6.45 3.045-9.795-1.35-13.24 2.8-3.443 4.148 2.819 8.416-.534 13.795-3.354 5.38-10.778 3.172-12.879 7.721-2.1 4.55 5.138 5.654 4.477 10.478-.662 4.823-6.771 2.742-7.618 9.992-.846 7.25 4.705 19.73 4.705 19.73z",
    id: "path30994",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.948 1023.41c1.698-27.142 16.94-51.5 42.655-79.326-15.714 15.325-44.589 45.623-44.914 81.28l2.259-1.954z",
    id: "path30996",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.549 988.827c4.412-3.87 8.351-4.929 12.362-6.413-3.815.907-7.606 1.673-11.71 4.304l-.652 2.109z",
    id: "path30998",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.083 967.686c5.28-2.797 9.34-2.946 13.584-3.495-3.899.027-7.736-.078-12.383 1.574l-1.2 1.921z",
    id: "path31000",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.548 972.043c1.107-5.392-.145-8.843-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672z",
    id: "path31002",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.887 991.964c1.108-5.393-.144-8.844-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672z",
    id: "path31004",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.389 -7.87)",
    id: "g3151",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.882 948.746c7.671-4.14 11.335-13.195 17.453-16.668 6.522-3.7 5.27 6.858 10.184 3.836 4.913-3.022 2.763-11.794 9.47-15.923 6.706-4.129 11.274 2.196 16.277-1.689 5.003-3.884-.853-9.918 5.69-14.032 6.545-4.114 13.6 2.827 21.565-1.327 7.78-4.059 13.956.92 10.236 8.274-2.474 4.891-8.14 6.57-11.955 13.762-3.816 7.192 1.473 11.399-3.634 15.037-5.106 3.638-10.19-3.92-16.792-.485-6.603 3.436-4.045 12.17-9.616 14.227-5.571 2.058-6.789-6.374-12.668-5.996-5.88.377-3.454 7.585-12.288 7.982-8.834.396-23.922-6.998-23.922-6.998z",
    id: "path30781",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.71 948.513c33.048.211 67.707-16.276 102.004-43.693-18.915 16.888-61.038 48.614-104.421 46.14l2.417-2.447z",
    id: "path30783",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.711 939.345c4.784-4.776 6.14-9.232 8.016-13.736-1.17 4.324-2.167 8.633-5.438 13.154l-2.578.582z",
    id: "path30785",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.664 925.434c3.495-5.863 3.745-10.53 4.487-15.378-.1 4.492-.04 8.923-2.13 14.148l-2.357 1.23z",
    id: "path30787",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.285 930.313c6.58-.846 10.756.873 15.296 2.204-3.96-1.787-7.8-3.702-13.234-3.917l-2.062 1.713z",
    id: "path30789",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.85 942.163c6.578-.846 10.755.873 15.294 2.204-3.96-1.788-7.8-3.703-13.234-3.917l-2.06 1.713z",
    id: "path30791",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3363",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.995 716.21c3.617-8.648.845-18.541 3.621-25.579 2.96-7.501 8.651 1.956 10.732-3.885 2.082-5.841-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.716-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.952-8.855 13.596-.308 1.094 5.684-2.453 10.95-.99 19.43 1.464 8.481 8.445 8.267 6.598 14.743-1.847 6.475-10.792 3.82-13.986 11.16-3.193 7.341 4.44 12.692 1.211 18.2-3.23 5.51-9.58-.517-14.13 3.837-4.548 4.353 2.01 8.552-4.934 14.954-6.943 6.402-23.931 10.764-23.931 10.764z",
    id: "path3075",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.933 724.398c27.051-22.571 44.801-59.844 55.31-105.767-4.673 26.766-18.817 81.581-55.723 109.423l.413-3.656z",
    id: "path3077",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.387 684.59c.861-7.18-.866-11.742-2.202-16.7 1.797 4.326 3.722 8.52 3.931 14.452l-1.729 2.248z",
    id: "path3079",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.683 655.404c-.88-7.177-3.642-11.15-6.12-15.606 2.774 3.725 5.64 7.29 7.259 12.982l-1.139 2.624z",
    id: "path3081",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.404 663.078c4.82-5.216 9.315-6.69 13.858-8.731-4.361 1.27-8.706 2.354-13.268 5.918l-.59 2.813z",
    id: "path3083",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.032 689.54c4.821-5.215 9.315-6.69 13.86-8.73-4.362 1.27-8.708 2.354-13.27 5.918l-.59 2.813z",
    id: "path3085",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3377",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.265 672.078c4.442-7.713 2.993-17.421 6.45-23.719 3.686-6.712 7.945 2.958 10.604-2.298 2.658-5.255-3.596-11.547.03-18.725 3.627-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.233-15.052 3.496-7.076 13.002-5.021 17.687-12.908 4.576-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.652 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506s-23.893 7.11-23.893 7.11z",
    id: "path3047",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.786 678.53c28.239-17.873 49.427-50.837 64.795-92.906-7.584 24.705-27.44 74.716-65.619 96.309l.824-3.404z",
    id: "path3049",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.172 645.053c1.664-6.678.571-11.212-.105-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904z",
    id: "path3051",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.248 619.036c.018-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335z",
    id: "path3053",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.13 626.127c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.891 2.583z",
    id: "path3055",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.305 649.56c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.892 2.583z",
    id: "path3057",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3391",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.742 775.935c-7.882-5.63-18.266-4.844-24.713-9.25-6.871-4.697 3.658-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.84-12.336-10.09-15.426-6.249-3.09-8.83 5.718-16.099 1.202-7.268-4.516-4.466-14.966-12.516-20.881-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.121 5.186 8.721.281 5.014-4.332 11.087-1.017 6.072 3.314 4.838 12.095 11.503 17.002 6.665 4.907 15.195-4.66 20.033-.107 4.837 4.554-2.412 9.907 1.015 15.593 3.427 5.686 8.9-.273 13.89 8.353 4.99 8.627 5.963 27.322 5.963 27.322z",
    id: "path3019",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.89 788.204c-17.083-33.105-50.624-59.625-94.197-80.421 25.684 10.602 77.378 37.099 97.749 81.634l-3.552-1.213z",
    id: "path3021",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.74 745.768c-6.968-2.434-11.845-1.602-17.037-1.264 4.655-.955 9.207-2.073 15.145-1.024l1.892 2.288z",
    id: "path3023",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.16 726.678c-7.31-.613-11.805 1.426-16.727 3.064 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75z",
    id: "path3025",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.536 729.655c-4.231-6.155-4.808-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218z",
    id: "path3027",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.394 748.242c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.679 1.218z",
    id: "path3029",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3405",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.693 843.39c5.85-6.617 6.32-16.43 10.93-21.87 4.915-5.796 7.205 4.571 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.331 4.947-6.265 11.317-1.946 14.743-7.376 3.427-5.43-4.058-9.018.741-15.21 4.8-6.194 13.71-2.18 19.831-8.916 5.98-6.581 13.42-4.099 12.338 4.135-.72 5.476-5.492 9.069-6.717 17.184-1.225 8.116 5.127 10.189 1.522 15.424-3.605 5.235-10.865-.06-15.942 5.516s.195 12.875-4.366 16.79c-4.56 3.915-8.473-3.576-13.875-1.13-5.402 2.445-.755 8.356-8.927 11.87-8.173 3.515-24.78 1.93-24.78 1.93z",
    id: "path2991",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.176 847.501c31.13-11.554 58.29-39.374 81.522-77.336-12.232 22.598-41.404 67.392-82.99 80.496l1.468-3.16z",
    id: "path2993",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.34 822.17c2.928-6.189 2.74-10.859 3.023-15.759.322 4.48.798 8.884-.792 14.296l-2.23 1.464z",
    id: "path2995",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.164 799.868c1.36-6.752.063-11.227-.832-16.046 1.38 4.256 2.893 8.399 2.644 14.051l-1.812 1.995z",
    id: "path2997",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.711 806.366c5.906-3.134 10.395-3.004 15.1-3.368-4.31-.271-8.548-.705-13.725 1.026l-1.375 2.342z",
    id: "path2999",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.635 826.192c5.906-3.134 10.396-3.004 15.1-3.368-4.31-.271-8.547-.705-13.725 1.025l-1.375 2.343z",
    id: "path3001",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(15 310.012 758.36)",
    id: "use4746",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#use4740"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(5 93.23 577.125)",
    id: "use4740",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g3115"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-10 274.952 690.264)",
    id: "use4744",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g3137"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(10 225.439 653.89)",
    id: "use4748",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g3151"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1 0 0 1 840 .113)",
    id: "palma_diestra",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 2.16505647,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    width: 1,
    height: 1,
    xlinkHref: "#palma_siniestra"
  })), /*#__PURE__*/React.createElement("g", {
    id: "escudo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.969 233.5l-79.063 98.438C204.1 356.885 218.95 398.608 219 432.53c.064 42.427-6.892 71.819-15.469 98.625-.09.284-.19.561-.281.844H420V235.5c-47.741 29.637-113.325 41.44-163.031-2z",
    id: 1,
    style: {
      fill: "#007ea8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.031 233.5c-49.706 43.44-115.29 31.637-163.031 2V532h216.75c-.091-.283-.19-.56-.281-.844-8.577-26.806-15.533-56.198-15.469-98.625.051-33.922 14.9-75.645 41.094-100.594L583.03 233.5z",
    id: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.25 532c-11.806 36.677-26.632 68.604-31.25 121.656-6.82 78.337 56.185 121.224 82.219 133.5 40.136 18.926 82.074 12.38 125 17.875 19.923 2.55 31.065 15.154 40.781 25.469 9.716-10.315 20.858-22.919 40.781-25.469 42.926-5.494 84.864 1.051 125-17.875 26.034-12.276 89.039-55.163 82.219-133.5-4.618-53.052-19.444-84.979-31.25-121.656h-433.5z",
    id: 3,
    style: {
      fill: "#d91023"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    id: "muebles"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.475 0 0 .5 -70.35 523.5)",
    id: "g16944",
    style: {
      fill: "#00a854",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4747",
    style: {
      fill: "#00a854",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.19079 .25564 .25564 -.19079 1009.389 -287.965)",
    id: "g16450-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16452-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16454-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16456-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16458-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16460-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16462-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16464-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16466-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16468-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16470-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16472-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16474-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-.31898 .31898) rotate(15 2214.31 -14980.66)",
    id: "g16476-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16478-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16480-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16482-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16484-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16486-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16488-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16490-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16492-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16494-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16496-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16498-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16500-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 4)",
    id: "g4531"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 1219.16 -191.914)",
    id: "g4504"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4507",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4509",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4511",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4513",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4515",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4517",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4519",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4521",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4523",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4525",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4527",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4529",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)",
    id: "g4490"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16582-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16584-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16586-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16588-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16590-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16592-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16594-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16596-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16598-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16600-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16602-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path16604-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.126 .29305 .29305 .126 1099.365 -378.459)",
    id: "g16658-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16660-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16662-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16664-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16666-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16668-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16670-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16672-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16674-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16676-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16678-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16680-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16682-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(.31898 -.31898) rotate(-81.119 2552.8 -1162.485)",
    id: "g16684-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16686-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16688-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16690-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16692-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16694-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16696-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16698-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16700-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16702-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16704-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16706-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16708-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.2665 .1753 .1753 .2665 1192.414 -515.002)",
    id: "g16710-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16712-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16714-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16716-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16718-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16720-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16722-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16724-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16726-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16728-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16730-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16732-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16734-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 2)",
    id: "g4777"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-.31898 .31898) rotate(15 3091.736 -16302.015)",
    id: "g16736-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16738-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16740-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16742-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16744-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16746-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16748-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16750-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16752-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16754-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16756-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16758-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16760-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(.31898 -.31898) rotate(-60 2794.502 -2391.599)",
    id: "g16814-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16816-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16818-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16820-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16822-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16824-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16826-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16828-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16830-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16832-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16834-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16836-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16838-8",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.08337 .3079 .3079 .08337 1210.008 -546.848)",
    id: "g16892-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16894-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16896-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16898-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16900-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16902-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16904-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16906-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16908-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16910-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16912-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16914-9",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16916-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-.31898 .31898) rotate(29.85 1192.349 -8562.057)",
    id: "g16918-3",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    id: "path16920-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    id: "path16922-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    id: "path16924-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    id: "path16926-0",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    id: "path16928-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    id: "path16930-6",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    id: "path16932-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    id: "path16934-7",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    id: "path16936-5",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    id: "path16938-4",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    id: "path16940-1",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    id: "path16942-2",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496137,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-32 -18)",
    id: "use4721",
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g4531"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-58 -32)",
    id: "g4723"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 1219.16 -191.914)",
    id: "g4725"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4727",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4729",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4731",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4733",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4735",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4737",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4739",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4741",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4743",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4745",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4747",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4749",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)",
    id: "g4751"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 1.862s-40.202 52.881-40 100c.202 47.119 33.027 73.976 40 100 6.973-26.024 39.798-52.881 40-100 .202-47.119-40-100-40-100z",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4753",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c-10.052-25.094-26.136-33.392-37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4755",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c-10.052-25.094-29.812-32.973-39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4757",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c-7.848-25.094-24.826-26.973-32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4759",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c-7.848-25.094-22.25-20.834-22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4761",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c-5.504-16.108-14.548-18.602-10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4763",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 192.362c10.052-25.094 26.136-33.392 37-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4765",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 162.362c10.052-25.094 29.812-32.973 39-70",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4767",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 126.362c7.848-25.094 24.826-26.973 32-64",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4769",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 90.362c7.848-25.094 22.25-20.834 22-52",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4771",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 58.362c5.504-16.108 14.548-18.602 10-40",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4773",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 221.862s-.167-52.833 0-94.5 1-124.5 1-124.5.833 82.833 1 124.5c.167 41.667 0 94.5 0 94.5",
    transform: "scale(.31898 -.31898) rotate(-45 2518.041 -3777.963)",
    id: "path4775",
    style: {
      fill: "#00a854",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.13496113,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-62 -40)",
    id: "use4805",
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g4777"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-31 -20)",
    id: "use4807",
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g4777"
  }))), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-1 0 0 1 2501 0)",
    id: "use4995",
    style: {
      fill: "#00a854",
      fillOpacity: 1
    },
    width: 744.094,
    height: 1052.362,
    xlinkHref: "#g4747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.5-437.125c-8.62 41.666-8.594 79.156-8.594 79.156-.505 13.948-7.41 23.678-13.781 20-54.887-31.689-60.291-37.57-89.125-59.669 24.306 26.461 31.231 38.23 86.719 70.266 10.728 6.193 12.062 16.378 11.625 29.469l-1.688 61.716c-.302 9.035 5.747 50.084-22.562 34.218-65.373-36.637-63.772-33.585-95.094-51.669 38.074 32.327 24.373 23.468 90.594 61.7 11.943 6.896 24.531 24.497 24.531 32.844 0 124.331 1.865 101.486-12.813 139.096h60.376c-14.678-37.61-12.813-14.765-12.813-139.096 0-8.347 12.588-25.948 24.531-32.844 66.221-38.232 51.52-29.373 89.594-61.7-31.322 18.084-28.72 15.032-94.094 51.67-28.309 15.865-22.26-25.184-22.562-34.22l-1.688-61.715c-.437-13.09.897-23.276 11.625-29.47 55.488-32.035 62.413-43.804 86.719-70.265-28.834 22.099-34.238 27.98-89.125 59.67-6.37 3.677-13.276-6.053-13.781-20 0 0 .027-37.49-8.594-79.157z",
    id: "path16444-0",
    style: {
      fill: "#947245",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.99999994,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09654 0 0 1.10361 -16.74 -70.25)",
    id: "vicu\\xF1a",
    style: {
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.452 424.637c-.25.946 1.503 12.373.546 15.66-.508 4.54-.635 5.238-1.704 11.12-1.069 5.881-2.364 17.308-4.391 24.163-.17.576-.408 1.358-.452 2.042-.567 3.502-.584 5.981-.211 10.35l3.512 19.415s1.634 1.918 1.881 2.722c.247.804-.172 2.006-.006 2.25.927 1.362 1.074 2.702 2.177 3.848.173.18.92.107 1.118.356.171.216 1.485.3 1.74.466.784.74.646 1.276 1.049 2.404l-6.321.026c.162-2.822-2.057-3.938-2.057-3.938-.244-.308-2.823-1.017-3.121-2.683-.413-2.392-.068-2.869-.068-2.869s-2.115-9.062-2.996-11.33c-.504-1.758-.605-2.592-.855-4.127-.76-4.24-1.017-6.075-3.32-12.405-.547-1.097-1.987-1.453-1.869-2.898.154-.557.427-.979.701-1.462l.072-1.11c.336-5.183.625-10.384 1.056-15.547a1.85 1.85 0 0 0 .236-.741c.602-8.797-4.079-17.02-7.1-24.897-.548-1.43-.075-2.995-.696-4.423-3.214-1.108-5.415-6.475-6.563-9.854-1.122-3.303-1.617-8.284-.764-11.589.278-1.077.434-1.814.964-2.522",
    id: "path3308",
    style: {
      fill: "#e3e4e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.323 443.746c1.026-.24 1.416-.319 2.51-.308 0 0 .74 1.02.959 1.499 1.529 2.753 3.371 15.341 4.434 21.193.33 1.814 1.094 5.943 1.434 7.866 0 0-.377 2.066.288 4.345.203.695.426 1.387.609 2.085.803 3.062 1.716 3.813 1.716 3.813.214.733 1.468 6.751 1.681 7.484 1.842 8.241 2.741 13.212 2.623 16.652-.115 4.714-.09 4.254.284 4.639 1.037 1.068 1.567.406 3.787 6.085.133.454.265-.217.505.234.287.538.78.477 1.18.53.73.096.59.23 1.181.307a6.248 6.248 0 0 0 1.58.015l5.461.037c-.67-1.992-2.887-3.369-4.828-3.386-.857-.528-1.85-1.282-2.155-2.287-1.251-2.003-1.608-2.427-2.262-3.335.108-.722-.414-1.692-.64-2.47l-1.958-23.232s.403-2.328.372-4.745c-.164-12.768.578-25.616 1.05-38.434.16-1.074 4.04-4.71 4.04-4.71",
    id: "path3310",
    style: {
      fill: "#e3e4e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z",
    id: "path3312",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.764 323.783a7.326 7.326 0 0 0-5.446 2.506c-1.794 2.47-2.967 7.56-3.098 10.618-.035.807.3 1.426.044 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.91 19.802-2 25.736-1.089 5.934-5.973 14.674-7.964 17.344-1.103 1.479-3.758 2.059-4.536 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.062-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.442 0 0-9.95-3.679-19.116-1.017-9.031 2.624-14.11 7.479-21.956 19.542 0 0-3.37 4.117-3.411 5.469-.13 4.35 1.704 9.806 5.009 12.67.061.053 1.08.703 1.143.754.142-7.013 1.286-10.356 1.286-10.356-.078 3.524.584 6.943 1.714 10.182.743 2.13 2.551 4.1 3.697 6.136 1.77 4.762 3.104 18.703 3.994 24.509.458 2.989-1.804 13.07-3.305 17.589-2.913 8.767-4.196 16.64-.763 10.708 1.53-2.643 7.366-13.736 10.364-24.067 2.998-10.332 5.923-16.314 5.012-18.412-.297-.682-1.144-15.014-1.338-15.572a8.51 8.51 0 0 1-.259-.872c-.077-.328-.282-.597-.062-1.732l1.42-7.337c14.683 27.28 38.082 30.661 53.957 11.605-2.393 7.736-2.493 18.98-2.215 23.723.279 4.743.24 2.713.161 4.375l-2.804 26.036-.25.513s-.634 1.432-.634 2.778c0 .635.025 1.365 0 2.197-.036 1.222-.009 1.903.143 2.09l.456.562c.027.929-.022 1.853-.09 2.778-.021.312-.054.714-.08 1.074l.348-.435c.981-1.227 1.525-3.112 1.929-5.324 0 0 .03-.198.053-.28.023-.084.099-.271.099-.271s.233-.636.428-1.442c.195-.807.232-1.53.232-1.53l-.152-.648.108-.658s4.958-29.989 4.964-30.15c.006-.161.122-.567.259-.842.947-1.325 3.07-2.802 3.857-3.707.805-.926 3.728-13.128 3.286-20.742-1.013-17.45 22.095-22.41 29.831-13.792 2.904-1.564 5.333-3.812 7.402-6.524 1.961-2.57 3.581-5.576 4.947-8.846.185-.655.41-1.365.571-1.985.43-1.646.77-3.155 1-4.433.192-1.06.348-2.122.483-3.184.134-1.061.25-2.125.348-3.194.197-2.137.336-4.296.509-6.504.173-2.208.374-4.461.687-6.795.157-1.166.35-2.353.572-3.561.222-1.209.478-2.44.786-3.698.132-.54.346-1.048.598-1.548s.543-.991.83-1.481c.288-.49.574-.981.813-1.49.239-.51.43-1.04.535-1.598l-.044-.406.794-.107c.004-.023.005-.055.01-.077-3.738.779-2.057.183-5.67.658-1.069 0-1.972-.063-2.83-.436-1.825-1.273-3.36-2.948-4.144-5.149 0-2.462.807-7.157 1.486-8.42 2.248-4.19 4.092-1.019 8.567.218 4.253 1.176 10.606 4.484 13.002 6.78.278.266 3.51.415 3.83.241.236-.127.497-.09.741-.174.003-.064.04-.136.054-.203.01-.06.002-.101.018-.165.098-.395.267-.858.267-1.19 0-.331-.01-.611-.035-.862-.03-.271-.077-.513-.161-.696-.088-.19-.162-.314-.241-.446a2.319 2.319 0 0 0-.58-.658c-.36-.292-.541-.675-.92-.88-2.81-2.42-4.043-4.224-6.018-6.089.33-.411.272-.616.152-1.297-.903-2.728-2.638-3.232-5.563-5.449-2.733-1.579-6.307-3.296-10.099-3.649h-1.634a6.724 6.724 0 0 0-.401-.01z",
    id: "path3321",
    style: {
      fill: "#d18219",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z",
    id: "path7626",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.265 343.818c0 .332-.169.795-.268 1.19-.015.064-.007.106-.017.165.083-.398.294-.837.294-1.22 0-.048-.009-.088-.009-.135z",
    id: "path3317",
    style: {
      fill: "#d39044",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.948 432.87c-2.059 8.327-7.182 10.024-3.42 17.087 0 0-1.618-.118-2.592-2.837-.487-1.36-.813-3.37-.696-6.343.059-1.486.228-3.212.544-5.218.158-1.002.352-2.075.587-3.222",
    id: "path3200",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.745 429.429c-2.058 8.327-7.182 10.024-3.42 17.087 0 0-2.025-.03-2.999-2.75-.487-1.359-.838-3.642-.858-5.371-.02-1.73.45-4.684.788-5.924.337-1.24 1.238-3.31 1.238-3.31",
    id: "path3202",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.773 418.39c-2.934 5.509-5.297 10.213-6.52 14.3-1.225 4.089-1.996 6.272.31 10.602 0 0-1.567-.817-3.628-4.632-.65-1.204-1.086-3.867-.789-6.592a30.55 30.55 0 0 1 .776-4.396c.207-.808.465-1.662.79-2.58",
    id: "path3196",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.502 414.884c-1.818 2.792-2.406 5.465-3.414 7.733-2.016 4.537-3.085 7.944-3.085 10.44 0 2.029-.357 3.709 1.905 7.156 0 0-1.061-.124-1.753-.543-.692-.419-1.56-1.194-2.269-2.62-.708-1.427-1.255-3.504-1.303-6.527-.024-1.511.478-3.745.89-5.217.413-1.473 1.807-4.55 1.807-4.55",
    id: "path3198",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.27 334.537c.119-.233-11.574-3.636-13.242-13.858 2.275-2.15 14.25 5.702 14.438 12.987",
    id: "path3227",
    style: {
      fill: "#d18219",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.423 320.825c.093.205 6.265.184 11.133 10.596-1.095-1.244-6.04 1.675-11.092-10.204",
    id: "path3231",
    style: {
      fill: "#000",
      fillOpacity: 0.50196078,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.707 335.545c.165-.134.396-.452.122-.75-5.102-3.192-4.857.706-8.443.706 1.71 0 1.706.234 2.345.926 2.32 2.515 3.917 2.265 5.976-.176",
    id: "path3235",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.193 349.763c-.565.67-2.538-.793-3.984-.967",
    id: "path3237",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.326 345.923s-.54-.438-4.32-.932c.004.07 2.605-2.673 2.835.29",
    id: "path3267",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.663 436.88a33.59 33.59 0 0 0-.914 1.815c-1.068 2.348-1.409 4.538.472 8.069 0 0-1.617-.117-2.591-2.837-.487-1.36-.813-3.37-.696-6.343.03-.743.086-1.546.175-2.414",
    id: "path3324",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.708 419.108s-1.55-6.161 2.09-13.014",
    id: "path4663",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.90903294,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.10666 -1.36953 1.23913 .11788 -563.601 1048.275)",
    id: "cornucopia",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none",
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.415 879.458c-2.045-1.515-4.023-6.243-3.27-8.842-2.694-2.22-9.659 2.184-6.276 8.588 3.354 6.388 7.986 5.85 9.57.267l-.024-.013z",
    id: "path36885",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.519 885.467c.56-3.612-.686-9.663-6.934-10.747-6.235-1.067-8.153 4.548-6.958 10.324 4.5-3.395 11.623-1.683 13.892.423z",
    id: "path36887",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.416 882.052c1.063-4.786 5.835-6.083 10.57-5.594-2.96-3.38-6.044-8.823-10.264-5.651-3.317 2.504-5.617 6.151-.299 11.225l-.008.02z",
    id: "path36889",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.77 879.344c.56-3.612 2.025-8.456 5.93-10.433-3.367-3.054-11.69-2.136-12.302 4.1-.632 6.231 3.047 7.49 6.383 6.307l-.01.026z",
    id: "path36891",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.887 919.375c5.28.85 12.283-1.796 10.307-13.708-1.878-11.299-10.192-14.04-10.816-11.348 4.77 1.667 4.154 17.65.475 25.103l.034-.047z",
    id: "path36893",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.765 918.122c5.294.946 13.706-2.13 9.908-13.822-3.71-11.462-12.224-10.052-12.808-7.164 4.779 1.845 6.512 13.045 2.871 21.008l.03-.022z",
    id: "path36895",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.728 918.168c3.859 3.455 13.822 4.688 17.015-6.829 3.011-10.905.276-14.41-3.62-16.18 1.943 5.672-5.07 21.665-13.412 22.991l.018.018z",
    id: "path36897",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.151 917.195c3.263-1.816 10.612-5.074 5.805-16.066-3.936-8.966-10.087-5.15-11.753-3.603 4.31 1.812 8.14 11.493 5.948 19.67z",
    id: "path36899",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.224 914.63c3.051-2.059 10.717-7.101 4.569-17.83-6.09-10.543-14.194-3.537-14.215-.648 3.563.888 9.641 9.955 9.673 18.46l-.027.017z",
    id: "path36901",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.718 907.263c2.017-2.81 7.176-9.719-.7-16.792-7.758-6.967-12.759 1.783-12.047 4.285 3.199-.447 10.595 5.25 12.77 12.52l-.023-.013z",
    id: "path36903",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.176 896.276c.56-3.612 2.045-12.624-7.034-14.705-8.902-2.034-9.573 8.603-8.069 10.431 2.395-2.185 10.557-1.078 15.103 4.274z",
    id: "path36905",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.892 914.922c3.375 4.144 13.412 7.063 18.657-4.145 4.966-10.665 2.772-14.71-.953-17.146 1.016 6.117-8.907 21.318-17.712 21.318l.009-.027z",
    id: "path36907",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.848 906.698c3.225 6.56 19.288 14.058 25.522 1.927 5.916-11.504 1.012-22.081-3.9-26.14 2.33 11.768-12.11 29.737-21.626 24.184l.004.029z",
    id: "path36909",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.366 898.402c7.864 17.16 24.132 14.152 29.643 1.691 5.229-11.823 3.75-18.756-2.177-24.424-4.094 15.2-12.2 23.738-27.49 22.705l.024.028z",
    id: "path36911",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.921 884.056c5.964 21.484 27.137 18.887 36.131 6.547 6.355-8.705 4.117-15.146.905-18.94-6.961 8.212-18.98 15.534-37.069 12.368l.033.025z",
    id: "path36913",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.98 870.931c.633 21.914 26.07 24.33 37.372 11.791 7.983-8.845 7.368-15.426 5.227-19.305-8.432 8.338-25.238 18.384-42.626 7.488l.026.026z",
    id: "path36915",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.703 850.203c-3.87 28.348 29.128 37.617 43.467 20.689 7.698-9.07 7.333-15.432 5.2-19.31-14.3 10.02-39.159 11.185-48.688-1.376l.021-.003z",
    id: "path36917",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46 823.53c-9.486 30.632 19.29 41.583 38.047 38.528 14.855-2.403 23.204-19.886 21.094-23.738-18.552 13.087-55.366 1.82-59.157-14.759l.016-.032z",
    id: "path36919",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.06 799.67c-12.676 29.897 15.364 47.446 38.583 45.69 15.216-1.153 27.753-7.06 27.202-19.552-22.745 8.013-58.219-5.432-65.807-26.134l.021-.004z",
    id: "path36921",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.966 774.93c-12.693 30.576 14.747 55.711 43.465 56.342 14.648.316 21.34-3.593 27.196-13.299-20.73 3.532-64.889-27.938-70.661-43.044z",
    id: "path36923",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.57 765.272c-11.333 35.923 80.312 80.423 84.993 33.705-21.913 11.482-81.753-20.668-84.992-33.705z",
    id: "path36925",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.523 755.606c-15.379 19.757 93.055 78.167 95.506 28.363-9.762 5.009-29.87.684-49.265-8.106-19.38-8.787-33.155-22.855-46.237-20.233l-.005-.024z",
    id: "path36927",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.962 751.12c19.613.483 61.382 30.938 89.302 36.03 17.874 3.25 32.459-4.197 24.146-35.544-28.487 29.115-82.917-17.824-111.77-6.766-2.968-1.407.62 8.346-1.655 6.276l-.023.004z",
    id: "path36929",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.738 755.54c19.01-11.796 58.328 10.083 86.15 11.273 17.08.697 38.39-18.62 24.406-47.052-21.874 37.6-82.887 7.493-108.6 27.333-1.927 4.301-.85 9.998-1.984 8.422l.028.025z",
    id: "path36931",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.104 756.761c20.232-14.78 61.569-6.196 88.05-8.343 17.572-1.444 43.746-32.009 19.805-57.475-14.86 53.842-64.483 27.223-107.269 58.258-2.12 5.473.796 8.86-.59 7.531l.005.03z",
    id: "path36933",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.385 751.966c16.663-15.72 57.604-14.669 81.93-27.066 16.32-8.304 32.874-43.645 4.386-61.42-2.962 56.707-55.186 38.963-87.452 80.94-.782 6.006 2.732 8.47 1.112 7.55l.025-.003z",
    id: "path36935",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.126 744.463c12.345-22.09 50.302-27.61 70.82-45.993 18.351-16.443 23.318-46.355-7.626-55.908-2.63 59.192-43.855 46.685-60.74 82.265-3.214 7.812-1.534 20.485-2.45 19.665l-.004-.029z",
    id: "path36937",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.504 721.914c12.654-20.094 22.161-13.181 42.356-33.822 17.383-17.772 22.62-60.366-7.793-61.346 4.545 51.455-15.245 51.997-29.134 79.625.503 6.14-3.665 15.957-5.404 15.54l-.025.003z",
    id: "path36939",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.81845 -.01183 -.02373 .69604 90.482 198.531)",
    id: "g4935",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      strokeWidth: 1.0135498,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.424 602.663l-10.497 5.67-49.929 153.76 18.14 40.066 17.139 2.478 20.712-1.52 30.737-138.479 8.666-56.418-21.061-12.406-13.907 6.85z",
    id: "path36883",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.0135498,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.263 597.474c.415 2.04.853 4.105 1.293 6.14 9.833-6.845 20.436-.176 23.345 15.636 2.902 15.806-3.027 38.861-13.668 56.633-6.681 14.63-14.639 32.223-16.986 56.246-1.823 18.767 1.856 41.713-2.283 62.595-2.528 10.013-7.857 9.093-18.2 8.451 4.162 6.833 9.334 10.587 16.036 10.365 14.42-3.208 24.74-16.165 28.494-44.84-4.283-23.95-3.188-47.936 9.852-72.08 11.634-11.987 22.336-25.543 26.268-49.987 1.883-12.145-.47-25.209-9.616-39.046-11.482-17.358-20.812-17.994-29.61-16.439-4.964 2.075-9.942 4.22-14.925 6.326z",
    id: "path36941",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.0135498,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00247 -.00021 .02872 .99753 -4.724 5.461)",
    id: "g4939",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-325.656 629.664c.001-3.088 2.01-5.59 4.489-5.59 2.478 0 4.487 2.502 4.488 5.59h-8.977z",
    transform: "matrix(-1.12872 4.68175 4.11721 1.5799 -2679.175 1243.086)",
    id: "path36943",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.16666076,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.504 723.041c-3.802 7.233-11.304 10.594-16.734 7.42-5.396-3.156-6.684-11.681-2.921-18.968 3.798-7.261 11.303-10.593 16.734-7.42 5.395 3.156 6.683 11.682 2.921 18.968z",
    id: "path36945",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.557 641.066c-2.604-3.571-6.329-5.807-10.315-5.098-2.38.416-4.722 1.872-6.674 3.928-.077-.335-.154-.67-.206-1.009-1.39-7.709 4.797-16.772 11.401-17.96 2.956-.504 5.787.562 8.115 2.677-1.25 2.797-1.784 5.89-1.26 8.804a15.217 15.217 0 0 0 1.071 3.588 18.318 18.318 0 0 0-2.107 5.066l-.025.003z",
    id: "path36947",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.305 632.437c-2.852-3.625-6.749-5.866-11.004-5.267-4.033.568-7.999 3.659-10.677 7.768a18.765 18.765 0 0 1-1.132-4.147c-1.379-8.954 6.038-19.14 13.72-20.221 1.936-.273 3.81.037 5.537.831-.14 1.345-.13 2.69.075 4.016.624 4.048 2.48 7.614 5.04 10.154-.948 2.18-1.497 4.524-1.564 6.837l.004.029z",
    id: "path36949",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.047 677.375c-.141.19-.302.418-.445.637-3.207-.469-6.187-2.176-8.529-4.746 2.477 2.462 5.648 3.974 8.97 4.08l.004.029z",
    id: "path36951",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.755 663.75c-4.083-2.303-7.247-6.804-8.091-12.286-1.336-8.673 5.853-18.57 13.294-19.617a9.12 9.12 0 0 1 2.192-.044c-2.664 3.71-4.224 8.47-3.54 12.915.442 2.867 1.507 5.478 3.055 7.652-3.307 2.732-5.946 6.931-6.89 11.347l-.02.033z",
    id: "path36953",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.333 689.203c-2.006.599-4.083.405-5.87-.778-4.37-2.896-5.54-10.496-2.61-16.944 2.96-6.423 8.955-9.313 13.354-6.392 1.681 1.11 2.896 2.926 3.583 5.133a7.544 7.544 0 0 0-5.375.382c-4.698 2.155-7.138 8.593-5.42 14.328a11.05 11.05 0 0 0 2.343 4.3l-.004-.03z",
    id: "path36955",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.393 693.964c-3.06-.953-5.817-3.465-7.408-7.237-2.952-6.974-.85-15.61 4.763-19.248 2.876-1.84 6.1-2.036 8.974-.859-.526 3.151-.222 6.56 1.094 9.65 1.357 3.231 3.617 5.555 6.195 6.745-2.549-.671-5.28-.316-7.754 1.269-3.12 2.021-5.157 5.613-5.848 9.619l-.016.061z",
    id: "path36957",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.279 743.409c-7.009-4.475-11.336-13.985-9.674-21.123 1.4-5.975 6.675-8.44 12.495-6.39-2.556 5.19-3.25 11.933-1.444 18.2 1.494 5.228 4.476 9.203 8.076 11.404-2.763.647-6.115.052-9.429-2.095l-.024.003z",
    id: "path36959",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.674 769.938a12.338 12.338 0 0 1-.917-.99c-5.64-6.455-7.08-16.8-3.218-22.981 3.619-5.802 10.678-5.957 16.217-.642-2.971 6.512-2.259 15.325 1.637 22.195-3.235-1.473-6.876-1.563-10.343.132a14.099 14.099 0 0 0-3.352 2.282l-.024.003z",
    id: "path36961",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.083 783.814c-5.381-.309-10.723-6.313-12.475-14.487-1.953-9.153 1.305-17.664 7.28-18.91l.266-.037c2.876 4.717 7.182 7.526 11.73 7.725.033.047.066.1.105.184-6.72 4.626-9.86 15.335-7.062 25.003.05.162.101.332.156.522z",
    id: "path36963",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.208 717.594c-6.588 2.105-14.435-2.685-17.468-10.685-3.008-7.997-.113-16.28 6.5-18.396 1.694-.526 3.484-.6 5.256-.335 1.523 4.76 4.285 8.457 7.625 10.57-1.374 4.536-1.511 9.759-.05 14.727.264.942.58 1.847.956 2.685-.853.576-1.786 1.082-2.823 1.405l.004.029z",
    id: "path36965",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.946 727.884c-7.013-4.51-11.361-13.99-9.673-21.123 1.673-7.11 8.767-9.257 15.78-4.754 2.025 1.297 3.856 3.048 5.367 5.022-4.177 5.416-5.767 13.84-3.536 21.6.128.504.303 1.023.48 1.514-2.54.328-5.486-.376-8.418-2.26z",
    id: "path36967",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.7 750.888c-3.681 7.63-11.189 10.503-16.705 6.352-5.491-4.115-6.942-13.723-3.283-21.381 3.681-7.63 11.188-10.503 16.704-6.352 5.486 4.115 6.941 13.715 3.284 21.381z",
    id: "path36969",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.434 703.142c-3.779 1.886-7.908 2.151-11.274.358-6.168-3.363-7.576-12.505-3.14-20.38 3.15-5.529 8.39-8.998 13.392-9.385 2.208 1.985 5.027 2.972 7.878 2.57.168.146.341.328.495.505-7.94 3.422-12.165 13.327-9.413 22.051a16.01 16.01 0 0 0 2.034 4.263l.028.018z",
    id: "path36971",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.18 666.044c1.218 7.903-4.118 15.27-10.446 16.162-6.308.888-12.472-4.831-13.693-12.763-.864-5.605 1.874-11.709 5.799-15.11 2.616 4.35 6.942 6.957 11.389 6.33 1.595-.224 3.156-.841 4.56-1.82a23.142 23.142 0 0 1 2.367 7.204l.024-.003z",
    id: "path36973",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.201 705.726c-5.672 2.926-12.188-1.39-14.474-9.664-2.285-8.275.45-17.434 6.142-20.392 1.763-.903 3.602-1.11 5.392-.73a25.498 25.498 0 0 0-1.654 3.538c-3.388 9.103-1.72 20.056 3.749 24.342.9.713 1.867 1.21 2.867 1.466a9.937 9.937 0 0 1-2.001 1.408l-.02.032z",
    id: "path36975",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5 667.948c.426 2.76-.017 5.464-1.083 7.859-5.203-3.176-12.142.017-15.889 7.242-4.182-1.796-7.535-6.13-8.367-11.533-1.183-7.679 5.123-16.42 11.7-17.457.027.342.078.674.13 1.012 1.146 7.435 7.098 12.89 13.466 12.427l.064.418-.02.032z",
    id: "path36977",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.513 696.658c-4.26 9.226-12.873 13.369-19.195 9.203-6.288-4.15-7.974-15.092-3.725-24.346 4.26-9.226 12.872-13.375 19.196-9.202 6.288 4.15 7.974 15.092 3.724 24.345z",
    id: "path36979",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.382 655.22c-1.417 2.99-3.648 5.49-6.347 6.878-6.282 3.152-13.95-.31-17.067-7.746-3.098-7.44.944-18.534 7.22-21.721 2.655-1.353 5.524-1.146 8.18.055-.028.151-.056.295-.079.475-1.667 9.692 1.944 19.186 8.093 22.06z",
    id: "path36981",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.61 614.137c.4 2.594.033 5.177-.908 7.437-2.47-3.075-5.82-4.959-9.444-4.448-4.329.61-8.583 4.542-10.675 9.378-2.219-2.219-3.83-5.297-4.372-8.812-1.197-7.774 5.22-16.611 11.888-17.55 6.643-.935 12.326 6.176 13.526 13.97l-.015.025z",
    id: "path36983",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.452 630.627c1.01 6.556-3.192 12.756-8.577 14.633-2.38-3.426-5.837-5.648-9.628-5.114a9.624 9.624 0 0 0-2.845.894c-1.484-1.919-2.569-4.327-2.985-7.028-1.13-7.341 4.957-15.736 11.26-16.623 6.308-.888 11.69 5.862 12.824 13.231l-.05.007z",
    id: "path36985",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.229 654.4c-3.093 1.87-6.583 2.104-9.461.235-5.117-3.394-6.486-12.284-3.047-19.782 3.457-7.501 10.464-10.872 15.58-7.486 2.723 1.802 4.368 5.14 4.824 9.044-5.169 3.775-8.978 11.09-7.955 17.732l.04.259.019-.003z",
    id: "path36987",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.479 798.67c-5.803 2.083-12.089-2.383-14.383-10.509-2.41-8.633.555-18.22 6.643-21.323 5.695-2.9 12.154.88 14.95 8.45-6.2 4.464-9.267 14.214-7.215 23.353l.004.03z",
    id: "path36989",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.605 803.782c-6.263 2.781-13.224-1.096-15.517-8.766-2.294-7.67.943-16.318 7.258-19.217 5.442-2.496 11.415.057 14.436 5.725-5.846 4.71-8.578 13.89-6.18 22.237l.003.021z",
    id: "path36991",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.557 817.92c-5.657 2.577-11.968-.899-14.041-7.797-1.382-4.663-.507-9.733 1.976-13.306 3.978 3.385 9.068 4.39 13.799 2.083a14.505 14.505 0 0 0 3-1.976 14.325 14.325 0 0 1 1.746 3.78c.713 2.373.828 4.889.445 7.24-2.093 2.252-3.666 5.204-4.587 8.498-.7.585-1.49 1.071-2.338 1.478z",
    id: "path36993",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.083 847.28c-6.371 2.907-13.464-1.01-15.799-8.786-2.325-7.754.966-16.497 7.33-19.403.46-.212.951-.391 1.45-.52-.24 3.08.033 6.288.932 9.415 2.072 7.178 6.908 11.988 12.306 13.068-1.376 2.755-3.518 5.014-6.215 6.255l-.004-.028z",
    id: "path36995",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.171 848.437c-6.135 2.792-12.96-.987-15.2-8.466a17.692 17.692 0 0 1-.001-9.943c4.011 3.6 9.243 4.704 14.112 2.348 2.663-1.295 4.898-3.48 6.55-6.207a16.606 16.606 0 0 1 1.591 3.596c2.239 7.479-.92 15.858-7.051 18.672z",
    id: "path36997",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.142 863.357c-6.142 2.793-12.968-.993-15.207-8.472-.611-2.041-.808-4.14-.683-6.197 2.383.415 4.88.086 7.294-1.056 4.181-2.024 7.283-6.259 8.816-11.362 3.03 1.414 5.585 4.388 6.8 8.42 2.238 7.471-.914 15.85-7.045 18.67l.025-.003z",
    id: "path36999",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.959 786.054c-2.764-1.739-5.05-4.729-6.214-8.59-2.452-8.252 1.007-17.505 7.788-20.616 6.75-3.108 14.31 1.09 16.794 9.337 1.87 6.236.33 13.062-3.474 17.366-3.14-1.972-6.987-2.409-10.58-.754-1.641.753-3.098 1.878-4.314 3.257z",
    id: "path37001",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.823 651.64c1.07 6.56-5.47 16.885-12.166 18.31-6.695 1.424-10.884-1.834-13.949-6.191-3.064-4.357-4.273-10.017-2.61-15.188 1.663-5.171 6.083-10.364 10.441-12.278 4.358-1.915 7.371-1.174 10.919 1.74 3.547 2.914 6.296 7.046 7.365 13.606z",
    id: "path37003",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.163 808.599c-6.136 2.785-12.968-.993-15.207-8.472-2.231-7.473.92-15.851 7.052-18.673 6.135-2.792 12.961.994 15.195 8.438 2.239 7.479-.913 15.857-7.044 18.678l.004.029z",
    id: "path37005",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.132 834.193c-6.042 2.742-12.815-.985-15.011-8.352-2.197-7.368.9-15.657 6.962-18.432 6.043-2.779 12.81.956 15.01 8.345 2.197 7.368-.893 15.656-6.96 18.439z",
    id: "path37007",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.76480764,
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M256.594 229.188l-1.969 2.437-79.063 98.438-1.718 2.156 2 1.906c25.393 24.187 40.106 65.356 40.156 98.406.064 42.097-6.787 71.07-15.313 97.719-11.777 36.812-26.994 69.242-31.687 123.156-3.483 40.01 10.941 71.184 29.469 93.688 18.527 22.503 41.077 36.466 54.469 42.781 41.107 19.383 83.522 12.7 125.906 18.125 18.828 2.41 29.201 14.193 38.969 24.563l2.187 2.312 2.188-2.313c9.767-10.369 20.14-22.152 38.968-24.562 42.384-5.425 84.8 1.258 125.906-18.125 13.392-6.315 35.942-20.278 54.47-42.781 18.527-22.504 32.951-53.677 29.468-93.688-4.693-53.914-19.91-86.344-31.688-123.156-8.525-26.649-15.375-55.622-15.312-97.719.05-33.05 14.763-74.22 40.156-98.406l2-1.906-1.718-2.156-79.063-98.438-1.969-2.438-2.343 2.063c-24.26 21.2-52.218 28.854-80.157 27.656-27.938-1.198-55.813-11.38-79.312-25.969L420 231.97l-1.594.969c-23.5 14.587-51.374 24.77-79.312 25.968-27.939 1.198-55.897-6.455-80.156-27.656l-2.344-2.063zm.844 8.5c24.9 20.687 53.608 28.432 81.906 27.218 27.405-1.175 54.405-10.547 77.656-24.125V529H207.344c8.181-26.17 14.718-55.32 14.656-96.469-.051-33.928-14.389-74.86-40.125-100.719l75.563-94.125zm325.125 0l75.562 94.125C632.389 357.67 618.051 398.603 618 432.53c-.062 41.149 6.475 70.3 14.656 96.469H423V240.781c23.251 13.578 50.252 22.95 77.656 24.125 28.298 1.214 57.005-6.531 81.906-27.219zM205.406 535h429.188c11.746 35.998 25.914 67.3 30.406 118.906 3.336 38.326-10.316 67.782-28.094 89.375-17.778 21.594-39.764 35.195-52.406 41.157-39.166 18.468-80.627 12.06-124.094 17.625-19.536 2.5-31.098 14.205-40.406 24.093-9.308-9.888-20.87-21.593-40.406-24.093-43.467-5.564-84.928.843-124.094-17.625-12.642-5.962-34.628-19.563-52.406-41.157-17.778-21.593-31.43-51.049-28.094-89.375 4.492-51.605 18.66-82.908 30.406-118.906z",
    id: "filete",
    style: {
      fill: "#e7ca00",
      fillOpacity: 1,
      stroke: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscudo);
export default __webpack_public_path__ + "static/media/escudo.d13d0434e2136eef8747fd56a9ac3e75.svg";
export { ForwardRef as ReactComponent };